import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { BarChart3, Activity, ScrollText, Users } from 'lucide-react';
import AdminDashboard from '../components/settings/AdminDashboard';
import PerformanceTab from '../components/settings/PerformanceTab';
import LogsTab from '../components/LogsTab';
import SourceAnalytics from '../components/analytics/SourceAnalytics';

const tabs = [
  { id: 'Dashboard', icon: BarChart3, label: 'Dashboard' },
  { id: 'Sources', icon: Users, label: 'User Sources' },
  { id: 'Performance', icon: Activity, label: 'Performance' },
  { id: 'Logs', icon: ScrollText, label: 'Request Logs' }
];

const PlatformData = ({ user }) => {
  const [activeTab, setActiveTab] = useState('Dashboard');

  if (user?.role !== 'platform_admin' && user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-background py-4 px-2 sm:py-8 sm:px-4 pb-20 md:pb-4">
      <div className="mx-auto bg-card rounded-lg shadow-sm flex flex-col md:flex-row overflow-hidden border border-border">
        {/* Sidebar */}
        <aside className="w-full md:w-64 bg-muted p-4 sm:p-6 rounded-t-lg md:rounded-l-lg md:rounded-tr-none">
          <div className="flex md:block items-center justify-between mb-4 md:mb-8">
            <h2 className="text-xl font-bold text-foreground hidden md:block">Analytics</h2>
          </div>
          {/* Mobile Navigation */}
          <nav className="md:hidden grid grid-cols-4 gap-1">
            {tabs.map(({ id, icon: Icon, label }) => (
              <button
                key={id}
                className={`flex flex-col items-center justify-center p-2 rounded-lg font-medium transition-colors duration-150 ${
                  activeTab === id
                    ? 'bg-[#1086a4] text-white'
                    : 'text-foreground hover:bg-primary/10 hover:text-primary'
                }`}
                onClick={() => setActiveTab(id)}
              >
                <Icon className="w-6 h-6 mb-1 stroke-[1.5]" />
                <span className="text-xs text-center">{label}</span>
              </button>
            ))}
          </nav>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex md:flex-col gap-2 space-y-2">
            {tabs.map(({ id, icon: Icon, label }) => (
              <button
                key={id}
                className={`flex items-center gap-3 text-left px-4 py-3 rounded-lg font-medium transition-colors duration-150 ${
                  activeTab === id
                    ? 'bg-[#1086a4] text-white shadow-inner'
                    : 'text-foreground hover:bg-primary/10 hover:text-primary'
                }`}
                onClick={() => setActiveTab(id)}
              >
                <Icon className="w-5 h-5 stroke-[1.5]" />
                <span>{label}</span>
              </button>
            ))}
          </nav>
        </aside>

        {/* Content */}
        <div className="flex-1 border-t md:border-t-0 md:border-l border-border overflow-x-auto">
          <div className="p-4 sm:p-6">
            {activeTab === 'Dashboard' && <AdminDashboard />}
            {activeTab === 'Sources' && <SourceAnalytics />}
            {activeTab === 'Performance' && <PerformanceTab />}
            {activeTab === 'Logs' && <LogsTab />}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user
});

export default connect(mapStateToProps)(PlatformData);
